
(() => {
  const root = document.getElementById("vipcase-model-selector-root");
  if (!root || root.dataset.enabled !== "true") return;

  const STORAGE_MODEL = "vipcaseSelectedPhoneModel";
  const STORAGE_MODEL_NAME = "vipcaseSelectedPhoneModelName";
  const STORAGE_BRAND = "vipcaseSelectedPhoneBrand";
  const STORAGE_DISMISSED_UNTIL = "vipcaseModelWidgetDismissedUntil";
  const SESSION_DISMISSED = "vipcaseModelWidgetDismissedSession";
  const DISMISS_DAYS = 7;

  const pageType = root.dataset.pageType || "";
  const path = window.location.pathname;
  const neverAutoOpen = ["cart", "checkout", "customers", "policy"];

  const pageExcluded =
    neverAutoOpen.includes(pageType) ||
    path.startsWith("/cart") ||
    path.startsWith("/checkout") ||
    path.startsWith("/account") ||
    path.startsWith("/policies");

  const productPage = pageType === "product" || path.startsWith("/products/");
  const shouldAutoOpenPage = !pageExcluded && !productPage;

  const state = {
    data: null,
    selectedBrand: null,
    selectedBrandIndex: null,
    selectedModel: null,
    query: ""
  };

  const STORE_OVERLAY_SELECTORS = [
    "#CartDrawer",
    "#hdt-quick-add-modal",
    "#hdt-quick-view-modal",
    ".hdt-drawer",
    ".hdt-modal",
    "hdt-lazy-modal[aria-modal='true']",
    "[aria-modal='true']"
  ];

  function normalize(value) {
    return String(value || "")
      .toLocaleLowerCase("tr-TR")
      .replaceAll("ı", "i")
      .replaceAll("İ", "i")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function track(eventName, payload = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      page_path: window.location.pathname,
      ...payload
    });
  }

  function isMobileViewport() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function setViewportHeight() {
    const vv = window.visualViewport;
    const height = vv ? vv.height : window.innerHeight;
    root.style.setProperty("--vms-viewport-height", `${Math.max(360, Math.round(height))}px`);

    const keyboardActive = vv && vv.height < window.innerHeight - 120;
    const compactViewport = isMobileViewport() && height <= 620;
    root.classList.toggle("vms-keyboard-active", Boolean(keyboardActive));
    root.classList.toggle("vms-compact-viewport", Boolean(keyboardActive || compactViewport));
  }

  function isStoreOverlayVisible(el) {
    if (!el || root.contains(el)) return false;

    const openState =
      el.hasAttribute("open") ||
      el.getAttribute("aria-hidden") === "false" ||
      el.getAttribute("aria-expanded") === "true";
    if (!openState && (el.hidden || el.hasAttribute("hidden"))) return false;

    const style = window.getComputedStyle(el);
    if (
      style.display === "none" ||
      style.visibility === "hidden" ||
      Number(style.opacity || 1) === 0
    ) {
      return false;
    }

    const rect = el.getBoundingClientRect();
    const inViewport =
      rect.width > 0 &&
      rect.height > 0 &&
      rect.bottom > 0 &&
      rect.right > 0 &&
      rect.top < window.innerHeight &&
      rect.left < window.innerWidth;
    if (!inViewport) return false;

    const dialogLike =
      el.getAttribute("aria-modal") === "true" ||
      ["dialog", "region"].includes(el.getAttribute("role"));
    const themeOverlay =
      el.classList.contains("hdt-drawer") ||
      el.classList.contains("hdt-modal") ||
      el.id === "CartDrawer" ||
      el.id === "hdt-quick-add-modal" ||
      el.id === "hdt-quick-view-modal";
    const fixedLayer = ["fixed", "sticky"].includes(style.position);

    return openState || ((dialogLike || themeOverlay) && fixedLayer);
  }

  function isStoreOverlayOpen() {
    const overlays = new Set();

    STORE_OVERLAY_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => overlays.add(el));
    });

    return Array.from(overlays).some(isStoreOverlayVisible);
  }

  function updateBubbleSuppression() {
    const suppressed = isStoreOverlayOpen();
    root.classList.toggle("vms-bubble-suppressed", suppressed);
    return suppressed;
  }

  function updateBubbleLayout() {
    applyWhatsappBubblePosition();
    applyBubbleOffset();
    updateBubbleSuppression();
  }

  function applyWhatsappBubblePosition() {
    const whatsappBubble = document.querySelector(".sp-wpshare-probtn");
    if (!whatsappBubble) return;

    if (!isMobileViewport()) {
      [
        "position",
        "left",
        "right",
        "bottom",
        "width",
        "maxWidth",
        "minHeight",
        "boxSizing",
        "justifyContent"
      ].forEach((property) => {
        whatsappBubble.style[property] = "";
      });
      return;
    }

    whatsappBubble.style.position = "fixed";
    whatsappBubble.style.left = "10px";
    whatsappBubble.style.right = "auto";
    whatsappBubble.style.bottom = "calc(18px + env(safe-area-inset-bottom, 0px))";
    whatsappBubble.style.width = "calc(50vw - 15px)";
    whatsappBubble.style.maxWidth = "calc(50vw - 15px)";
    whatsappBubble.style.minHeight = "52px";
    whatsappBubble.style.boxSizing = "border-box";
    whatsappBubble.style.justifyContent = "center";
  }

  function applyBubbleOffset() {
    if (!isMobileViewport()) {
      root.style.setProperty("--vms-bubble-bottom", "18px");
      return;
    }

    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    let obstructionHeight = 0;

    Array.from(document.querySelectorAll("body *")).forEach((el) => {
      if (!el || root.contains(el) || el.id === "vipcase-model-selector-root") return;
      if (el.closest(".sp-wpshare-probtn")) return;

      const style = window.getComputedStyle(el);
      if (!["fixed", "sticky"].includes(style.position)) return;

      const rect = el.getBoundingClientRect();
      const visible =
        style.display !== "none" &&
        style.visibility !== "hidden" &&
        Number(style.opacity || 1) !== 0 &&
        rect.width > 0 &&
        rect.height > 0;
      const nearBottom = rect.top >= viewportHeight * 0.45 && rect.bottom > viewportHeight * 0.55;
      const withinViewport = rect.bottom <= viewportHeight + 12;
      const relevantWidth = rect.width >= viewportWidth * 0.35;
      const relevantHeight = rect.height >= 36 && rect.height <= 180;

      if (visible && nearBottom && withinViewport && relevantWidth && relevantHeight) {
        obstructionHeight = Math.max(obstructionHeight, viewportHeight - rect.top);
      }
    });

    const bottom = obstructionHeight > 0 ? Math.ceil(obstructionHeight + 14) : 18;
    root.style.setProperty("--vms-bubble-bottom", `${bottom}px`);
  }

  function getDismissedUntil() {
    const raw = localStorage.getItem(STORAGE_DISMISSED_UNTIL);
    const n = raw ? Number(raw) : 0;
    return Number.isFinite(n) ? n : 0;
  }

  function setDismissedForDays(days) {
    const until = Date.now() + days * 24 * 60 * 60 * 1000;
    localStorage.setItem(STORAGE_DISMISSED_UNTIL, String(until));
    sessionStorage.setItem(SESSION_DISMISSED, "1");
  }

  function hasSelectedModel() {
    return Boolean(localStorage.getItem(STORAGE_MODEL));
  }

  function selectedLabel() {
    const name = localStorage.getItem(STORAGE_MODEL_NAME);
    return name ? `Modeliniz: ${name}` : "Telefon modelinizi seçin";
  }

  function whatsappUrl() {
    const phone = root.dataset.whatsappPhone || "905325687277";
    const message = "Merhaba, telefon modelime uygun kılıf bulmak istiyorum. Modelim:";
    return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  }

  function modelMatches(model, query) {
    if (!query) return true;
    const q = normalize(query);
    const haystack = [model.name, model.handle, ...(model.aliases || [])].map(normalize).join(" ");
    return haystack.includes(q);
  }

  function getModelsForSelectedBrand() {
    if (!state.selectedBrand) return [];
    return state.selectedBrand.models || [];
  }

  function filteredModels() {
    return getModelsForSelectedBrand()
      .filter((model) => modelMatches(model, state.query))
      .slice(0, 80);
  }

  function findStoredSelection() {
    const handle = localStorage.getItem(STORAGE_MODEL);
    if (!handle || !state.data?.brands) return null;

    for (let brandIndex = 0; brandIndex < state.data.brands.length; brandIndex += 1) {
      const brand = state.data.brands[brandIndex];
      const model = (brand.models || []).find((item) => item.handle === handle);
      if (model) return { brand, brandIndex, model };
    }

    return null;
  }

  function createModal() {
    const overlay = document.createElement("div");
    overlay.className = "vms-overlay vms-hidden";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", "Telefon model seçici");

    overlay.innerHTML = `
      <div class="vms-modal">
        <div class="vms-header">
          <button type="button" class="vms-close" aria-label="Kapat">×</button>
          <h2 class="vms-title">Telefon modelinizi seçin</h2>
          <p class="vms-subtitle">Marka ve modelinizi seçin, telefonunuza uygun kılıfları hemen gösterelim.</p>
        </div>
        <div class="vms-body">
          <div class="vms-field">
            <div class="vms-label-row">
              <label class="vms-label" for="vms-brand">Marka seç</label>
              <button type="button" class="vms-tiny-btn vms-reset-all vms-hidden">Seçimi temizle</button>
            </div>
            <select id="vms-brand" class="vms-select">
              <option value="">Marka seçin</option>
            </select>
          </div>

          <div class="vms-field">
            <div class="vms-label-row">
              <label class="vms-label" for="vms-search">Model ara veya seç</label>
            </div>
            <input id="vms-search" class="vms-input" type="search" placeholder="Örn: iPhone 15, S24 Ultra, Note 12" autocomplete="off" disabled>
            <div class="vms-selected vms-hidden"></div>
            <div class="vms-results vms-hidden"></div>
          </div>

          <div class="vms-actions">
            <button type="button" class="vms-primary" disabled>Kılıfları Göster</button>
            <button type="button" class="vms-secondary">Modelimi bulamadım</button>
          </div>
        </div>
      </div>
    `;
    root.appendChild(overlay);
    return overlay;
  }

  function createBubble() {
    const bubble = document.createElement("button");
    bubble.type = "button";
    bubble.className = "vms-bubble";
    bubble.innerHTML = `<span class="vms-bubble-icon">⌕</span><span class="vms-bubble-text"></span>`;
    root.appendChild(bubble);
    return bubble;
  }

  const modal = createModal();
  const bubble = createBubble();

  const els = {
    close: modal.querySelector(".vms-close"),
    brand: modal.querySelector("#vms-brand"),
    search: modal.querySelector("#vms-search"),
    results: modal.querySelector(".vms-results"),
    selected: modal.querySelector(".vms-selected"),
    primary: modal.querySelector(".vms-primary"),
    secondary: modal.querySelector(".vms-secondary"),
    resetAll: modal.querySelector(".vms-reset-all"),
    actions: modal.querySelector(".vms-actions"),
    body: modal.querySelector(".vms-body"),
    bubbleText: bubble.querySelector(".vms-bubble-text")
  };

  let resultsScrollFrame = null;
  let bubbleLayoutFrame = null;
  let bubbleLayoutTimer = null;

  function updateActionSpace() {
    const height = els.actions.getBoundingClientRect().height || 120;
    root.style.setProperty("--vms-actions-height", `${Math.ceil(height)}px`);
  }

  function scheduleBubbleLayout(delay = 0) {
    if (bubbleLayoutTimer) window.clearTimeout(bubbleLayoutTimer);

    bubbleLayoutTimer = window.setTimeout(() => {
      if (bubbleLayoutFrame) window.cancelAnimationFrame(bubbleLayoutFrame);
      bubbleLayoutFrame = window.requestAnimationFrame(() => {
        bubbleLayoutFrame = null;
        updateBubbleLayout();
      });
    }, delay);
  }

  function scheduleBubbleLayoutSweep() {
    scheduleBubbleLayout(80);
    [220, 520, 900].forEach((delay) => {
      window.setTimeout(updateBubbleLayout, delay);
    });
  }

  function watchStoreOverlays() {
    const observer = new MutationObserver(() => scheduleBubbleLayout());

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"]
    });

    if (document.body) {
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ["class", "open", "hidden", "aria-hidden", "aria-expanded"],
        childList: true,
        subtree: true
      });
    }

    document.addEventListener("click", scheduleBubbleLayoutSweep, true);
    document.addEventListener("keyup", scheduleBubbleLayoutSweep, true);
  }

  function keepResultsInView() {
    setViewportHeight();
    updateActionSpace();

    if (!isMobileViewport() || modal.classList.contains("vms-hidden")) return;
    if (!state.selectedBrand || els.results.classList.contains("vms-hidden")) return;

    const bodyRect = els.body.getBoundingClientRect();
    const searchRect = els.search.getBoundingClientRect();
    const resultsRect = els.results.getBoundingClientRect();
    const actionsRect = els.actions.getBoundingClientRect();
    const compact = root.classList.contains("vms-keyboard-active") || root.classList.contains("vms-compact-viewport");
    const bottomGap = compact ? 44 : 10;
    const bottomLimit = Math.min(actionsRect.top, bodyRect.bottom) - bottomGap;
    const topLimit = bodyRect.top + 8;

    let scrollDelta = Math.max(0, resultsRect.bottom - bottomLimit);
    const maxScrollDelta = Math.max(0, searchRect.top - topLimit);
    scrollDelta = Math.min(scrollDelta, maxScrollDelta);

    if (scrollDelta > 0) {
      els.body.scrollTop += Math.ceil(scrollDelta);
    }
  }

  function scheduleResultsIntoView(delay = 0) {
    if (resultsScrollFrame) window.cancelAnimationFrame(resultsScrollFrame);

    window.setTimeout(() => {
      resultsScrollFrame = window.requestAnimationFrame(() => {
        resultsScrollFrame = null;
        keepResultsInView();
      });
    }, delay);
  }

  function updateBubble() {
    els.bubbleText.textContent = selectedLabel();
  }

  function renderBrands() {
    const brands = state.data?.brands || [];
    els.brand.innerHTML = `<option value="">Marka seçin</option>` + brands
      .map((brand, index) => `<option value="${index}">${brand.name}</option>`)
      .join("");
  }

  function renderResults() {
    if (!state.selectedBrand) {
      els.results.classList.add("vms-hidden");
      els.results.innerHTML = "";
      return;
    }

    const models = filteredModels();
    els.results.classList.remove("vms-hidden");

    if (!models.length) {
      els.results.innerHTML = `
        <div class="vms-empty">
          Bu aramayla model bulunamadı. Modelinizi WhatsApp üzerinden bize yazabilirsiniz.
        </div>
        <button type="button" class="vms-result" data-not-found="1">Modelimi bulamadım</button>
      `;
      scheduleResultsIntoView();
      return;
    }

    els.results.innerHTML = models.map((model) => {
      const selected = state.selectedModel?.handle === model.handle ? " is-selected" : "";
      return `<button type="button" class="vms-result${selected}" data-handle="${model.handle}">${model.name}</button>`;
    }).join("");
    scheduleResultsIntoView();
  }

  function renderSelected() {
    const hasModel = Boolean(state.selectedModel);
    els.resetAll.classList.toggle("vms-hidden", !hasModel);

    if (!hasModel) {
      els.selected.classList.add("vms-hidden");
      els.selected.innerHTML = "";
      els.primary.disabled = true;
      return;
    }

    els.selected.classList.remove("vms-hidden");
    els.selected.innerHTML = `
      <div class="vms-selected-main">
        <div class="vms-selected-title">
          <strong>${state.selectedModel.name}</strong>
          <span>${state.selectedBrand?.name || ""} için uygun kılıflar</span>
        </div>
        <button type="button" class="vms-clear">Temizle</button>
      </div>
    `;
    els.primary.disabled = false;
  }

  function hydrateStoredSelection() {
    const stored = findStoredSelection();
    if (!stored) return;

    state.selectedBrand = stored.brand;
    state.selectedBrandIndex = stored.brandIndex;
    state.selectedModel = stored.model;
    state.query = "";

    els.brand.value = String(stored.brandIndex);
    els.search.disabled = false;
    els.search.placeholder = "Modelinizi yazın veya listeden seçin";
    els.search.value = "";

    renderSelected();
    renderResults();
  }

  function openModal(source = "manual") {
    setViewportHeight();
    updateBubbleLayout();
    updateActionSpace();
    modal.classList.remove("vms-hidden");
    document.documentElement.style.overflow = "hidden";
    track("vipcase_model_widget_open", { source });

    setTimeout(() => {
      if (!state.selectedBrand) {
        if (!isMobileViewport()) els.brand.focus();
        return;
      }

      els.search.focus({ preventScroll: true });
      scheduleResultsIntoView();
    }, 60);
  }

  function closeModal(source = "close") {
    modal.classList.add("vms-hidden");
    document.documentElement.style.overflow = "";
    setDismissedForDays(DISMISS_DAYS);
    track("vipcase_model_widget_close", { source });
  }

  function selectModel(model) {
    state.selectedModel = model;
    renderSelected();
    renderResults();

    localStorage.setItem(STORAGE_MODEL, model.handle);
    localStorage.setItem(STORAGE_MODEL_NAME, model.name);
    localStorage.setItem(STORAGE_BRAND, state.selectedBrand?.name || "");
    localStorage.removeItem(STORAGE_DISMISSED_UNTIL);
    updateBubble();

    track("vipcase_model_model_select", {
      brand: state.selectedBrand?.name,
      model: model.name,
      collection_handle: model.handle
    });
  }

  function clearSelection(source = "clear_button") {
    const previousModel = localStorage.getItem(STORAGE_MODEL_NAME);
    const previousBrand = localStorage.getItem(STORAGE_BRAND);

    localStorage.removeItem(STORAGE_MODEL);
    localStorage.removeItem(STORAGE_MODEL_NAME);
    localStorage.removeItem(STORAGE_BRAND);
    localStorage.removeItem(STORAGE_DISMISSED_UNTIL);

    state.selectedModel = null;
    state.query = "";
    els.search.value = "";

    updateBubble();
    renderSelected();
    renderResults();

    track("vipcase_model_clear", {
      source,
      previous_brand: previousBrand || null,
      previous_model: previousModel || null
    });

    setTimeout(() => {
      els.search.focus({ preventScroll: true });
      scheduleResultsIntoView();
    }, 30);
  }

  function submitSelection() {
    const model = state.selectedModel;
    const brand = state.selectedBrand;
    if (!model || !brand) return;

    localStorage.setItem(STORAGE_MODEL, model.handle);
    localStorage.setItem(STORAGE_MODEL_NAME, model.name);
    localStorage.setItem(STORAGE_BRAND, brand.name);
    localStorage.removeItem(STORAGE_DISMISSED_UNTIL);
    updateBubble();

    track("vipcase_model_submit", {
      brand: brand.name,
      model: model.name,
      collection_handle: model.handle,
      target_url: model.url
    });

    window.location.href = model.url;
  }

  function notFound() {
    track("vipcase_model_not_found_click", {
      brand: state.selectedBrand?.name || null,
      query_normalized: normalize(state.query || "") || null
    });
    window.location.href = whatsappUrl();
  }

  els.close.addEventListener("click", () => closeModal("x"));
  modal.addEventListener("click", (event) => {
    if (event.target === modal) closeModal("overlay");
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !modal.classList.contains("vms-hidden")) closeModal("escape");
  });

  bubble.addEventListener("click", () => {
    track("vipcase_model_widget_bubble_click", {
      selected_model: localStorage.getItem(STORAGE_MODEL_NAME) || null
    });
    openModal("bubble");
  });

  els.brand.addEventListener("change", () => {
    const index = Number(els.brand.value);
    state.selectedBrand = Number.isInteger(index) && state.data.brands[index] ? state.data.brands[index] : null;
    state.selectedBrandIndex = state.selectedBrand ? index : null;
    state.selectedModel = null;
    state.query = "";

    els.search.value = "";
    els.search.disabled = !state.selectedBrand;
    els.search.placeholder = state.selectedBrand ? "Modelinizi yazın veya listeden seçin" : "Önce marka seçin";

    renderSelected();
    renderResults();

    if (state.selectedBrand) {
      track("vipcase_model_brand_select", { brand: state.selectedBrand.name });
      setTimeout(() => {
        els.search.focus({ preventScroll: true });
        scheduleResultsIntoView(80);
        scheduleResultsIntoView(260);
      }, 30);
    }
  });

  els.search.addEventListener("focus", () => {
    setViewportHeight();
    updateActionSpace();
    scheduleResultsIntoView(120);
    scheduleResultsIntoView(320);
  });

  els.search.addEventListener("input", () => {
    state.query = els.search.value;
    renderResults();
    scheduleResultsIntoView();
  });

  els.results.addEventListener("click", (event) => {
    const button = event.target.closest(".vms-result");
    if (!button) return;

    if (button.dataset.notFound) {
      notFound();
      return;
    }

    const handle = button.dataset.handle;
    const model = getModelsForSelectedBrand().find((item) => item.handle === handle);
    if (model) selectModel(model);
  });

  els.selected.addEventListener("click", (event) => {
    if (event.target.closest(".vms-clear")) clearSelection("selected_box");
  });

  els.resetAll.addEventListener("click", () => clearSelection("top_clear"));
  els.primary.addEventListener("click", submitSelection);
  els.secondary.addEventListener("click", notFound);

  async function init() {
    setViewportHeight();
    updateBubbleLayout();
    updateBubble();
    watchStoreOverlays();

    try {
      const response = await fetch(root.dataset.modelsUrl, { credentials: "same-origin" });
      if (!response.ok) throw new Error(`Model data failed: ${response.status}`);
      state.data = await response.json();
    } catch (error) {
      console.warn("[VipCase Model Selector]", error);
      bubble.classList.add("vms-hidden");
      return;
    }

    renderBrands();
    hydrateStoredSelection();

    const dismissedUntil = getDismissedUntil();
    const dismissedInSession = sessionStorage.getItem(SESSION_DISMISSED) === "1";
    const shouldAutoOpen =
      shouldAutoOpenPage &&
      !hasSelectedModel() &&
      !dismissedInSession &&
      Date.now() > dismissedUntil;

    const delay = window.matchMedia("(max-width: 749px)").matches ? 1000 : 1500;
    if (shouldAutoOpen) setTimeout(() => openModal("auto"), delay);

    window.addEventListener("resize", () => {
      setViewportHeight();
      scheduleBubbleLayout();
      scheduleResultsIntoView();
      scheduleResultsIntoView(160);
      scheduleResultsIntoView(360);
    }, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", () => {
        setViewportHeight();
        scheduleBubbleLayout();
        scheduleResultsIntoView(80);
        scheduleResultsIntoView(260);
        scheduleResultsIntoView(520);
      }, { passive: true });
      window.visualViewport.addEventListener("scroll", () => {
        setViewportHeight();
        scheduleBubbleLayout();
        scheduleResultsIntoView();
        scheduleResultsIntoView(180);
      }, { passive: true });
    }

    setTimeout(updateBubbleLayout, 600);
    setTimeout(updateBubbleLayout, 1800);
  }

  init();
})();
